import { GetDealByIdQuery } from '@/lib/graphql/generated/graphql';
import type { ErrorLike } from '@apollo/client';
import { atom } from 'jotai';

export type DealFromQuery = NonNullable<GetDealByIdQuery['deal']>;

export const dealAtom = atom<DealFromQuery | null>(null);
export const dealErrorAtom = atom<ErrorLike | undefined>(undefined);
export const dealRefetchAtom = atom<{ fn: () => Promise<void> }>({
  fn: async () => {},
});
export const dealSignalAtom = atom(0);
// Tracks which dealId is currently loaded in dealAtom (to skip redundant fetches on navigation)
export const dealLoadedForIdAtom = atom<string | null>(null);
